import React, { FC, HTMLAttributes, ImgHTMLAttributes } from 'react'

import normal from '../../images/icons/types/normal'
import fire from '../../images/icons/types/fire'
import water from '../../images/icons/types/water'
import electric from '../../images/icons/types/electric'
import grass from '../../images/icons/types/grass'
import ice from '../../images/icons/types/ice'
import fighting from '../../images/icons/types/fighting'
import poison from '../../images/icons/types/poison'
import ground from '../../images/icons/types/ground'
import flying from '../../images/icons/types/flying'
import psychic from '../../images/icons/types/psychic'
import bug from '../../images/icons/types/bug'
import rock from '../../images/icons/types/rock'
import ghost from '../../images/icons/types/ghost'
import dragon from '../../images/icons/types/dragon'
import dark from '../../images/icons/types/dark'
import steel from '../../images/icons/types/steel'
import fairy from '../../images/icons/types/fairy'

import { PokemonType } from '../../helpers/types'

interface Props extends React.SVGAttributes<SVGElement> {
    type: PokemonType
}

const PokemonTypeIcon: FC<Props> = ({ type, ...rest }) => {
    let Icon = normal
    switch (type) {
        case PokemonType.Normal:
            Icon = normal
            break;
        case PokemonType.Fire:
            Icon = fire
            break;
        case PokemonType.Water:
            Icon = water
            break;
        case PokemonType.Electric:
            Icon = electric
            break;
        case PokemonType.Grass:
            Icon = grass
            break;
        case PokemonType.Ice:
            Icon = ice
            break;
        case PokemonType.Fighting:
            Icon = fighting
            break;
        case PokemonType.Poison:
            Icon = poison
            break;
        case PokemonType.Ground:
            Icon = ground
            break;
        case PokemonType.Flying:
            Icon = flying
            break;
        case PokemonType.Psychic:
            Icon = psychic
            break;
        case PokemonType.Bug:
            Icon = bug
            break;
        case PokemonType.Rock:
            Icon = rock
            break;
        case PokemonType.Ghost:
            Icon = ghost
            break;
        case PokemonType.Dragon:
            Icon = dragon
            break;
        case PokemonType.Dark:
            Icon = dark
            break;
        case PokemonType.Steel:
            Icon = steel
            break;
        case PokemonType.Fairy:
            Icon = fairy
            break;
                 
    }
    return <Icon {...rest} />
}

export default PokemonTypeIcon